<!--
<div fxLayout="row" fxLayoutAlign="center center" id="component-splash-screen" *ngIf="!isComponentGotItData">
  <div class="spinner-wrapper">
    <div class="spinner">
      <div class="inner">
        <div class="gap"></div>
        <div class="left">
          <div class="half-circle"></div>
        </div>
        <div class="right">
          <div class="half-circle"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div fxLayout="column" class="rest-of" fxFlex="1 0 auto" *ngIf="isComponentGotItData">
  <div class="reply-wrapper" fxLayout="column" fxFlex="1 0 auto">
    <div fxLayout="row" class="reply-header">
      <span class="ellipsis" matTooltip="{{currentChatConversation?.title}} ({{messages?.length}})">{{currentChatConversation?.title}} ({{messages?.length}})</span>
    </div>
    <div id="messagecontainer" fxFlex="1 0 auto" class="w-p-100" fusePerfectScrollbar style="height: 0;z-index: 0">
      <a *ngIf="topIndex>0" (click)="loadOlderMessages()" class="load-msg">Load older messages</a>
      <div *ngFor="let messageObj of messages | slice: topIndex:lastIndex; let i = index" class="message-container"
           @fadeIn
           (mouseover)="messageObj.hover=true" (mouseleave)="messageObj.hover=false"

      >
        <div *ngIf="messageObj.isDeleted && (messageObj.systemMessageType=== 'NON_SYSTEM_MESSAGE' || messageObj.systemMessageType=== 0)" fxLayout="row" fxLayoutAlign="start center" class="deleted-text message-box me">
          <i class="far fa-exclamation-circle"></i><span>{{messageObj.createdBy?.firstName}} {{messageObj.createdBy?.lastName}} removed a message</span>
        </div>
        <div *ngIf="!messageObj.isDeleted && (messageObj.systemMessageType=== 'NON_SYSTEM_MESSAGE' || messageObj.systemMessageType=== 0)"
             [ngClass]="messageObj.isMine ? ((messageObj.messageType === 'CHAT' || messageObj.messageType === 1) ? 'reply-box me' : 'reply-box me white') : 'reply-box others'">


          <div fxLayout="row" fxLayoutAlign="start start">
            <collaboration-avatar [gravatarInfo]="messageObj.createdBy" [showGroupAvatar]="false"></collaboration-avatar>
            <div fxLayout="column" class="user-section">
              <span class="user-name" *ngIf="messageObj.messageType === 'CHAT' || messageObj.messageType === 1">{{messageObj.createdBy?.firstName}} {{messageObj.createdBy?.lastName}}</span>
              <div class="message" fxLayout="row wrap" [innerHTML]="messageObj.message | sanitizeHtml"></div>
              <span *ngIf="messageObj.data && messageObj.data[0]">
                <button (click)="onRevertToOldValue(messageObj.data[0])" class="revert-value">
                  Revert
                </button>
              </span>
            </div>
          </div>


          <div fxLayout="row" fxLayoutAlign="end center">
            <span (click)="removeMessage(messageObj)" class="trash"
                  [ngStyle]="{display: (messageObj.isMine) && (messageObj.messageType === 'CHAT' || messageObj.messageType === 1)? 'block' : 'none' }">
        <i class="fal fa-trash-alt"></i>
      </span>
          </div>
          <span class="timing">
            {{messageObj.createdDate | date:'MM/dd/yyyy'}}
          </span>

        </div>
      </div>
      <a *ngIf="lastIndex<messages?.length" (click)="loadNewerMessages()" class="load-msg">Load newer messages</a>
    </div>

    &lt;!&ndash;    <div class="reply-footer">
          <a href="#">
            <i class="far fa-reply"></i>
          </a>
        </div>&ndash;&gt;
  </div>

</div>

<div class="chat-footer">
  <ul id="contactListContainer" class="auto-sug-container" (click)="onClick($event)" *ngIf="currentSourceOfMatch === 'plusIndex' && showAutoSuggestionList && matchedContacts && matchedContacts.length">
    <li *ngFor="let contact of matchedContacts; let indx = index"
        [value]="contact.name"
        (click)="onSelect(contact.user, contact.email)"
        [ngClass]="{'focus-background': focusedElementIndex === indx}">
      <a href="javascript:void(0)">
        <collaboration-avatar [gravatarInfo]="contact.email" [showGroupAvatar]="false"></collaboration-avatar>
        <div fxLayout="column">
          <span>{{contact.user?.firstName?contact.user?.firstName: ''}} {{contact.user?.lastName? contact.user?.lastName: ''}}</span>
          <span class="component-label">{{contact.email}}</span>
        </div>
      </a>
    </li>
  </ul>
  <ul id="hashListContainer" class="auto-sug-container" (click)="onClick($event)" *ngIf="currentSourceOfMatch === 'hashIndex' && showAutoSuggestionList && matchedHashList && matchedHashList.length">
    <li *ngFor="let hashList of matchedHashList; let indx= index"
        [value]="hashList"
        (click)="onSelect(hashList)"
        [ngClass]="{'focus-background': focusedElementIndex === indx}">
      <a href="javascript:void(0)">
        <span># {{hashList}}</span>
      </a>
    </li>
  </ul>

  &lt;!&ndash;<textarea type="text" placeholder="Enter message..." [(ngModel)]="chatText" (ngModelChange)="onChanges($event)" id="textarea-input-box"></textarea>&ndash;&gt;
 &lt;!&ndash; <kendo-editor [(ngModel)]="chatText" name="content" (change)="onChanges($event, 'change')" (input)="onChanges($event, 'input')" (cut)="onChanges($event, 'cut')" (paste)="onChanges($event, 'paste')"></kendo-editor>&ndash;&gt;
 <div id="collaboration-textarea"
       contenteditable="true"
       placeholder="Add a comment..."></div>
  <div class="chat-footer-btn-container" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button>
        <i class="fal fa-paperclip"></i>
      </button>
      <button mat-icon-button>
        <i class="fal fa-smile"></i>
      </button>
      <div>
        <button mat-icon-button [matMenuTriggerFor]="userMenu"
                class="user-button">
          <i class="fal fa-ellipsis-h"></i>
        </button>

        <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

          <button mat-menu-item>

            <span>Sample Text 01</span>
          </button>

          <button mat-menu-item class="">
            <span>Sample Text 02</span>
          </button>


        </mat-menu>
      </div>
    </div>
    <button mat-icon-button (click)="sendMessage()" matTooltip="Info about the action"><i class="fal fa-paper-plane"></i></button>
  </div>


</div>
-->
<conversation
  [focusEditorAutomaticallyOnInit]="false"
  [conversationListComponentName]="collaborationConversationListComponentName"
  [conversationComponentName]="conversationComponentName"
></conversation>
